module.exports = __webpack_public_path__ + "static/media/main.02f266de.svg";